import React, { useState, useEffect, useRef, useCallback } from "react";
import {
  CardTitle,
} from "reactstrap";
//redux
import { connect } from "react-redux";
//paginação
import Pagination from "../../../../components/Paginationv3";
// backdrops
import Alert from '../../../../components/Backdrops/Alert';
import Loading from '../../../../components/Backdrops/Loading';
// router
import { useLocation } from "react-router-dom";
//hooks
import useDebounce from "../../../../utils/hooks/useDebounce";
//service
import reportService from "../../../../utils/services/accreditation/report";
import plusXMiceIdService from "../../../../utils/services/accreditation/plusXMiceId";
import PlusXMiceIdModel from '../../../../utils/models/PlusXMiceIdModel';
import scheduleService from "../../../../utils/services/accreditation/schedule";
import groupService from "../../../../utils/services/accreditation/group";
import writeXlsxFile from "write-excel-file";
import moment from 'moment';

import CommandButtons from './CommandButtons';
import EventNotActive from './EventNotActive';
import SummaryCards from './SummaryCards';
import GuestsList from './GuestsList';
import ModalGuestHistory from './ModalGuestHistory';

const NO_GROUP_LABEL = 'Sem Grupo';

const STATUS_LABELS = {
  show: 'Show',
  pending: 'Pendente',
  noShow: 'No Show',
};

function GuestsReportPage(props) {

  const location = useLocation();
  const eventId = location.state.idEvent;

  const [loadingControl, setLoadingControl] = useState({
    open: false,
    message: '',
  });
  const [alertControl, setAlertControl] = useState({
    open: false,
    title: '',
    message: '',
    status: '', // success, warning, error
  });
  const [plusXMiceId, setPlusXMiceId] = useState(PlusXMiceIdModel());
  const plusXMiceIdRef = React.useRef(PlusXMiceIdModel());
  const [groups, setGroups] = useState([]);
  const [schedules, setSchedules] = useState([]);

  // contagens de participantes do evento (TB_PAX), usadas nos cards de resumo
  const [guestCounts, setGuestCounts] = useState({ total: 0, noShow: 0, show: 0, pending: 0 });

  // contagens de check-in por grupo, consolidadas a partir de groups + getScheduleGuestsCount
  const [groupCounts, setGroupCounts] = useState([]);
  const [loadingGroupCounts, setLoadingGroupCounts] = useState(false);

  // página atual da busca de participantes (nome/e-mail/cpf/código interno/instituição),
  // já filtrada e paginada pelo backend
  const [guestsList, setGuestsList] = useState([]);
  const [guestsTotal, setGuestsTotal] = useState(0);
  const [loadingGuestsList, setLoadingGuestsList] = useState(false);

  const isMountedRef = React.useRef(false);

  // filtros
  const [search, setSearch] = useState('');
  const debouncedSearch = useDebounce(search, 300);
  const [scheduleFilter, setScheduleFilter] = useState('');
  const scheduleFilterRef = useRef(scheduleFilter);
  const [statusFilter, setStatusFilter] = useState('all');
  const [groupFilter, setGroupFilter] = useState('');

  useEffect(() => {
    scheduleFilterRef.current = scheduleFilter;
    getCheckinsCount();
  }, [scheduleFilter]);

  // paginação da busca de participantes, feita no backend
  const [currentIndex, setCurrentIndex] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const [modalGuestHistoryControl, setModalGuestHistoryControl] = useState({
    open: false,
    guest: null,
    checkinsList: [],
  });

  useEffect(() => {
    isMountedRef.current = true;
    getData();
  }, []);

  // volta pra primeira página sempre que um filtro é alterado
  useEffect(() => {
    if (isMountedRef.current) {
      setCurrentIndex(1);
    }
  }, [debouncedSearch, scheduleFilter, statusFilter, groupFilter]);

  // busca os participantes da programação selecionada, filtrando por status de check-in,
  // grupo e texto pesquisado (nome, e-mail, cpf, código interno ou instituição), com
  // paginação feita no backend
  useEffect(() => {
    getGuestsList();
  }, [scheduleFilter, statusFilter, groupFilter, debouncedSearch, currentIndex, itemsPerPage]);

  // busca todos os participantes de uma programação, aplicando os mesmos filtros de
  // status, grupo e busca da tabela, paginando pelo mesmo endpoint que alimenta o
  // GuestsList
  const fetchAllGuestsBySchedule = React.useCallback(async (scheduleId) => {
    const _miceId = plusXMiceIdRef.current.miceId;

    let _offset = 0;
    let _perPage = 500;
    let _guestsList = [];
    let _guestsCount = 0;
    do {
      const _ret = await reportService.searchGuests(
        _miceId,
        scheduleId,
        groupFilter,
        statusFilter,
        debouncedSearch,
        _perPage,
        _offset,
      );
      _offset += _perPage;
      _guestsList = [..._guestsList, ..._ret.data];
      _guestsCount = _ret.count;

    } while (_guestsCount > _guestsList.length);
    return _guestsList;
  }, [groupFilter, statusFilter, debouncedSearch]);

  const getData = React.useCallback(async () => {
    try {
      setLoadingControl({ open: true, message: 'Carregando' });

      let _plusXMiceId = { ...plusXMiceIdRef.current };
      if (!_plusXMiceId.miceId) {
        _plusXMiceId = await plusXMiceIdService.getPlusXMiceId(eventId);
        plusXMiceIdRef.current = _plusXMiceId;
        setPlusXMiceId(_plusXMiceId);
        if (!_plusXMiceId.active) {
          return;
        }
      }

      const _groups = await groupService.getGroupsApi(_plusXMiceId.miceId);
      setGroups(_groups);

      const _schedules = await scheduleService.getSchedules(_plusXMiceId.miceId);

      setSchedules(_schedules.data);
      if (_schedules.data.length > 0) {
        setScheduleFilter(_schedules.data[0].id);
      }

    } catch (error) {
      console.log('Error getData', error);
      setAlertControl({
        open: true,
        title: 'Erro',
        message: error.message || 'Não foi possível realizar esta operação',
        status: 'error', // success, warning, error
      });
    } finally {
      setLoadingControl({ open: false });
    }
  }, []);

  const getCheckinsCount = useCallback(async () => {
    const _miceId = plusXMiceIdRef.current.miceId;
    const _scheduleId = scheduleFilterRef.current;

    if (!_miceId || !_scheduleId || _scheduleId === 'all') {
      setGuestCounts({ total: 0, noShow: 0, show: 0, pending: 0 });
      setGroupCounts([]);
      return;
    }

    let _totalCounts;
    try {
      setLoadingControl({ open: true, message: 'Buscando' });

      const _guestsCount = await reportService.getScheduleGuestsCount(_miceId, _scheduleId);

      _totalCounts = {
        total: _guestsCount.totalPax || 0,
        noShow: _guestsCount.paxNoShow || 0,
        show: _guestsCount.paxShow || 0,
        pending: _guestsCount.paxPending || 0,
      };
      setGuestCounts(_totalCounts);
    } catch (error) {
      console.log('Error getCheckinsCount', error);
      setAlertControl({
        open: true,
        title: 'Erro',
        message: error.message || 'Não foi possível realizar esta operação',
        status: 'error', // success, warning, error
      });
      setLoadingControl({ open: false });
      return;
    }
    setLoadingControl({ open: false });

    if (groups.length === 0) {
      setGroupCounts([]);
      return;
    }

    try {
      setLoadingGroupCounts(true);

      const _sortedGroups = [...groups].sort((a, b) => a.text.localeCompare(b.text));

      const _counts = await Promise.all(
        _sortedGroups.map((group) => reportService.getScheduleGuestsCount(
          _miceId,
          _scheduleId,
          group.id,
        )),
      );

      const _namedGroups = _sortedGroups.map((group, index) => ({
        id: group.id,
        text: group.text,
        show: _counts[index].paxShow || 0,
        pending: _counts[index].paxPending || 0,
        noShow: _counts[index].paxNoShow || 0,
        total: _counts[index].totalPax || 0,
      }));

      const _noGroup = _namedGroups.reduce((acc, group) => ({
        show: acc.show - group.show,
        pending: acc.pending - group.pending,
        noShow: acc.noShow - group.noShow,
        total: acc.total - group.total,
      }), { ..._totalCounts });

      setGroupCounts([
        { id: 'no-group', text: NO_GROUP_LABEL, ..._noGroup },
        ..._namedGroups,
      ]);
    } catch (error) {
      console.log('Error getCheckinsCount (groups)', error);
      setGroupCounts([]);
    } finally {
      setLoadingGroupCounts(false);
    }
  }, [groups]);

  const getGuestsList = useCallback(async () => {
    const _miceId = plusXMiceIdRef.current.miceId;
    const _scheduleId = scheduleFilterRef.current;

    if (!_miceId || !_scheduleId || _scheduleId === 'all') {
      setGuestsList([]);
      setGuestsTotal(0);
      return;
    }

    try {
      setLoadingGuestsList(true);

      const _offset = (currentIndex - 1) * itemsPerPage;
      const _ret = await reportService.searchGuests(
        _miceId,
        _scheduleId,
        groupFilter,
        statusFilter,
        debouncedSearch,
        itemsPerPage,
        _offset,
      );

      setGuestsList(_ret.data);
      setGuestsTotal(_ret.count);
    } catch (error) {
      console.log('Error getGuestsList', error);
      setAlertControl({
        open: true,
        title: 'Erro',
        message: error.message || 'Não foi possível realizar esta operação',
        status: 'error', // success, warning, error
      });
    } finally {
      setLoadingGuestsList(false);
    }
  }, [groupFilter, statusFilter, debouncedSearch, currentIndex, itemsPerPage]);

  const getReport = React.useCallback(async () => {
    try {
      setLoadingControl({ open: true, message: 'Buscando' });

      if (schedules.length === 0) {
        throw new Error('Nenhuma programação encontrada para gerar o relatório');
      }

      const _guestsBySchedule = [];
      for (const schedule of schedules) {
        const _guestsList = await fetchAllGuestsBySchedule(schedule.id);
        _guestsBySchedule.push({ schedule, guestsList: _guestsList });
      }

      await createXlsx(_guestsBySchedule);

    } catch (error) {
      console.log('Error getReport', error);
      setAlertControl({
        open: true,
        title: 'Erro',
        message: error.message || 'Não foi possível realizar esta operação',
        status: 'error', // success, warning, error
      });
    } finally {
      setLoadingControl({ open: false });
    }

    async function createXlsx(guestsBySchedule = []) {
      const schema = [
        {
          column: "ID",
          type: String,
          value: (guest) => guest.id.toString(),
        },
        {
          column: "Nome",
          type: String,
          value: (guest) => guest.nome,
        },
        {
          column: "E-mail",
          type: String,
          value: (guest) => guest.email,
        },
        {
          column: "Código Interno",
          type: String,
          value: (guest) => guest.codigoInterno,
        },
        {
          column: "Grupo",
          type: String,
          value: (guest) => groups.find((g) => `${g.id}` === `${guest.grupoId}`)?.text || NO_GROUP_LABEL,
        },
        {
          column: "Status",
          type: String,
          value: (guest) => STATUS_LABELS[guest.status] || guest.status,
        },
      ];

      await writeXlsxFile(
        guestsBySchedule.map((item) => item.guestsList),
        {
          schema: guestsBySchedule.map(() => schema),
          sheets: guestsBySchedule.map((item, index) => toSheetName(item.schedule.title, index)),
          fileName: `Relatório de Participantes Evento ${plusXMiceIdRef.current.miceId} - ${moment().format('YYYY-MM-DD HH-MM')}.xlsx`,
        },
      );
    }

    // remove caracteres não permitidos em nomes de aba do Excel e respeita o limite de 31 caracteres
    function toSheetName(title = '', index = 0) {
      const _sanitized = title.replace(/[:\\/?*[\]]/g, '-').trim() || `Programação ${index + 1}`;
      return _sanitized.slice(0, 31);
    }
  }, [schedules, fetchAllGuestsBySchedule, groups]);

  // busca todos os participantes do evento com o indicador de check-in por programação
  // (relatório geral), paginando pelo endpoint getGeneralReport
  const fetchGeneralReport = React.useCallback(async () => {
    const _miceId = plusXMiceIdRef.current.miceId;

    let _offset = 0;
    let _perPage = 500;
    let _guestsList = [];
    let _guestsCount = 0;
    let _schedules = [];
    do {
      const _ret = await reportService.getGeneralReport(_miceId, _perPage, _offset);
      _offset += _perPage;
      _guestsList = [..._guestsList, ..._ret.data];
      _guestsCount = _ret.count;
      _schedules = _ret.schedules;

    } while (_guestsCount > _guestsList.length);
    return { guestsList: _guestsList, schedules: _schedules };
  }, []);

  const getGeneralReport = React.useCallback(async () => {
    try {
      setLoadingControl({ open: true, message: 'Buscando' });

      const { guestsList, schedules: _schedules } = await fetchGeneralReport();

      await createXlsx(guestsList, _schedules);

    } catch (error) {
      console.log('Error getGeneralReport', error);
      setAlertControl({
        open: true,
        title: 'Erro',
        message: error.message || 'Não foi possível realizar esta operação',
        status: 'error', // success, warning, error
      });
    } finally {
      setLoadingControl({ open: false });
    }

    async function createXlsx(list = [], scheduleColumns = []) {
      const schema = [
        {
          column: "ID",
          type: String,
          value: (guest) => guest.id.toString(),
        },
        {
          column: "Nome",
          type: String,
          value: (guest) => guest.nome,
        },
        {
          column: "E-mail",
          type: String,
          value: (guest) => guest.email,
        },
        ...scheduleColumns.map((schedule) => ({
          column: schedule.title,
          type: String,
          value: (guest) => guest.checkins?.[schedule.id] ? 'Sim' : '',
        })),
      ];

      await writeXlsxFile(list, {
        schema,
        fileName: `Relatório Geral Evento ${plusXMiceIdRef.current.miceId} - ${moment().format('YYYY-MM-DD HH-MM')}.xlsx`,
      });
    }
  }, [fetchGeneralReport]);

  // busca o histórico completo de check-ins de um participante, em todas as programações
  const getGuestHistory = React.useCallback(async (guest = {}) => {
    try {
      setLoadingControl({ open: true, message: 'Buscando' });

      const _checkins = await reportService.getGuestSchedulesPass(
        plusXMiceIdRef.current.miceId,
        0,
        1000,
        guest.id,
      );

      setModalGuestHistoryControl({
        open: true,
        guest,
        checkinsList: _checkins.data,
      });
    } catch (error) {
      console.log('Error getGuestHistory', error);
      setAlertControl({
        open: true,
        title: 'Erro',
        message: error.message || 'Não foi possível realizar esta operação',
        status: 'error', // success, warning, error
      });
    } finally {
      setLoadingControl({ open: false });
    }
  }, []);

  if (!plusXMiceId.active) {
    return (
      <EventNotActive />
    )
  }
  return (
    <div>
      <CardTitle>Relatório de Participantes</CardTitle>
      <CommandButtons
        search={search}
        setSearch={setSearch}
        schedules={schedules}
        scheduleFilter={scheduleFilter}
        setScheduleFilter={setScheduleFilter}
        statusFilter={statusFilter}
        setStatusFilter={setStatusFilter}
        groupFilter={groupFilter}
        setGroupFilter={setGroupFilter}
        groups={groups}
        refreshData={getData}
        getReport={getReport}
        getGeneralReport={getGeneralReport}
      />
      <SummaryCards
        guestCounts={guestCounts}
        groups={groups}
        groupCounts={groupCounts}
        loadingGroupCounts={loadingGroupCounts}
      />
      <GuestsList
        guestsList={guestsList}
        groups={groups}
        loading={loadingGuestsList}
        getGuestHistory={getGuestHistory}
      />
      <Pagination
        data={guestsList}
        search={debouncedSearch}
        currentIndex={currentIndex}
        setCurrentIndex={setCurrentIndex}
        countData={guestsTotal}
        maxItemPerPage={itemsPerPage}
        setMaxItemPerPage={setItemsPerPage}
        maxPageButtonsToShow={3}
      />

      <Loading loadingControl={loadingControl} />
      <Alert
        alertControl={alertControl}
        setAlertControl={setAlertControl}
      />
      {modalGuestHistoryControl.open && (
        <ModalGuestHistory
          modalGuestHistoryControl={modalGuestHistoryControl}
          setModalGuestHistoryControl={setModalGuestHistoryControl}
        />
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  return { state };
};

export default connect(mapStateToProps)(GuestsReportPage);
